'use client';

import { IcBoldSearch, IcCloseCircle, IconButton, TextField } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import { useDebouncedInput } from '../../common/hooks/useDebounceCallback';

interface ProductSearchInputProps {
  onSearch: (keyword: string) => void;
  className?: string;
}

export const ProductSearchInput = ({ onSearch, className }: ProductSearchInputProps) => {
  const [keyword, handleKeywordChange, syncKeyword] = useDebouncedInput<string>('', onSearch, 300);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    handleKeywordChange(value);
  };

  const handleClear = () => {
    syncKeyword('');
    onSearch('');
  };

  return (
    <div className={twMerge('relative px-4 pb-3', className)}>
      <div className="inline-flex relative w-full">
        <TextField
          autoFocus
          fullWidth
          className="bg-white pr-12"
          variant="outlined"
          value={keyword}
          onChange={handleInputChange}
          placeholder="상품명/브랜드명 또는 키워드를 입력하세요"
        />

        {keyword.length > 0 && (
          <IconButton className="absolute right-32 top-2" size="size20x20" onClick={handleClear}>
            <IcCloseCircle fillColor="gray-400" />
          </IconButton>
        )}
        <IconButton className="absolute right-8 top-8" size="size20x20">
          <IcBoldSearch strokeColor="gray-500" />
        </IconButton>
      </div>
    </div>
  );
};
